import { render, staticRenderFns } from "./EmailTemplate.vue?vue&type=template&id=4fdd2ebd&"
import script from "./EmailTemplate.vue?vue&type=script&lang=ts&"
export * from "./EmailTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./EmailTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports